import React, { useEffect, useMemo, useRef } from "react";
import ArticleSearchContainer from "../../../containers/ArticleSearchContainer";
import { handleChangeIds } from "../../../../utils/checkBoxFunc";

type AreaFilterOption = {
  value: string;
  label: string;
};

type Props = {
  options: AreaFilterOption[];
};

function PortalPCAreaFilterCheckboxList({ options }: Props) {
  const { areaIds, setAreaIds, search } = ArticleSearchContainer.useContainer();
  const normalizedAreaIds = Array.isArray(areaIds) ? areaIds : [];
  const onChange = handleChangeIds(normalizedAreaIds, setAreaIds);
  const isFirstRender = useRef(true);
  const optionIds = useMemo(
    () => options.map((option) => option.value),
    [options]
  );

  const selectedOptionIdsKey = useMemo(
    () =>
      normalizedAreaIds
        .filter((id) => optionIds.includes(id))
        .sort()
        .join(","),
    [normalizedAreaIds, optionIds]
  );

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    search();
  }, [selectedOptionIdsKey]);

  return (
    <section className="portalPcAreaFilter">
      <h2 className="portalPcAreaFilterHeading">
        <i className="fa fa-map-marker" aria-hidden="true" />
        <span>{options.length}区で絞り込む</span>
      </h2>
      <div className="portalPcAreaFilterBox">
        <ul className="portalPcAreaFilterList">
          {options.map((option) => {
            const id = `portal-pc-area-filter-${option.value}`;
            return (
              <li key={option.value}>
                <label htmlFor={id}>
                  <input
                    id={id}
                    type="checkbox"
                    value={option.value}
                    checked={normalizedAreaIds.includes(option.value)}
                    onChange={onChange}
                  />
                  <span>{option.label}</span>
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}

export default PortalPCAreaFilterCheckboxList;
